<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="70%">
      <v-card>
        <v-card-title>
          <span class="text-h5 align-center">{{ title }}</span>
          <v-col class="d-flex flex-row justify-end">
            <v-btn small @click="loadData">
              <v-icon small title="Buscar">fas fa-search</v-icon>
            </v-btn>
            <v-btn small @click="add" v-show="selected && selected.length">
              <v-icon small title="Adicionar">fas fa-plus</v-icon>
            </v-btn>
            <v-btn small @click="hide">
              <v-icon small title="Fechar">fas fa-window-close</v-icon>
            </v-btn>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="5">
                <v-text-field
                  dense
                  label="Código"
                  v-model="product.productCode"
                  outlined
                />
              </v-col>
              <v-col cols="7">
                <v-text-field
                  dense
                  label="Descrição"
                  v-model="product.description"
                  outlined
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  dense
                  outlined
                  v-model="product.carrierId"
                  :items="carriers"
                  item-text="name"
                  item-value="id"
                  label="Operadora"
                  :clearable="true"
                  :loading="this.carriers.length == 0"
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                  dense
                  outlined
                  v-model="product.productFamilyId"
                  :items="productFamilies"
                  item-text="name"
                  item-value="id"
                  label="Produto Operadora"
                  :clearable="true"
                  :loading="this.productFamilies.length == 0"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  dense
                  outlined
                  v-model="product.benefitId"
                  :items="benefits"
                  item-text="name"
                  item-value="id"
                  label="Benefício"
                  :clearable="true"
                  :loading="this.benefits.length == 0"
                ></v-select>
              </v-col>
            </v-row>
            <v-data-table
              dense
              v-model="selected"
              :headers="headers"
              :items="items"
              :loading="isSearching"
              item-key="id"
              locale="pt-BR"
              show-select
              class="elevation-1 mt-2"
              :single-select="single" 
            >
              <template v-slot:item.isActive="{item}">
                {{ item.isActive ? 'Sim' : 'Não' }}
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import ProductService from '@/services/odoo/ProductService';
import BenefitService from '@/services/odoo/BenefitService';
import CarrierService from '@/services/odoo/CarrierService';
import ProductFamilyService from '@/services/odoo/ProductFamilyService';

let initialData = {
  product: {},
  selected: [],
  items: [],
  totalElements: 0,
};

export default {
  props: {
    acceptanceRuleId: {
      type: String,
    },
    title: {
      type: String,
      require: true,
    },
    single: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      benefits: [],
      carriers: [],
      productFamilies: [],
      options: {},
      headers: [
        {text: 'Código', align: 'left', value: 'productCode', sortable: true},
        {
          text: 'Descrição',
          align: 'left',
          value: 'description',
          sortable: false,
        },
        {text: 'Ativo', align: 'end', value: 'active', sortable: false},
      ],
      isSearching: false,
      singleSelect: false,
      ...initialData,
    };
  },
  async created() {
    this._productService = new ProductService();
    this._benefitService = new BenefitService();
    this._carrierService = new CarrierService();
    this._productFamilyService = new ProductFamilyService();
  },
  watch: {
    options: {
      handler() {
        this.loadData();
      },
      deep: true,
    },
  },
  methods: {
    resetData() {
      for (const prop in initialData) {
        this[prop] = initialData[prop];
      }
    },
    async loadData() {
      this.isSearching = true;
      const {sortBy, sortDesc, page, itemsPerPage} = this.options;
      const {data} = await this._productService.findAllByParams(
        Object.assign(this.product, {
          //exceptAcceptanceRuleId: this.acceptanceRuleId,
          page: page ? page - 1 : 0,
          sortBy: sortBy && sortBy.length ? sortBy[0] : 'productCode',
          descending: sortDesc && sortDesc.length ? sortDesc[0] : false,
          size: itemsPerPage,
        }),
      );
      this.items = data.content;
      this.totalElements = data.totalElements;
      this.isSearching = false;
      this.$emit('on-load');
    },
    show() {
      this.resetData();
      this.dialog = true;
      if (
        this.benefits.length ||
        this.carriers.length ||
        this.productFamilies.length
      )
        return;
      this._benefitService.findAll().then((res) => (this.benefits = res.data.records));
      this._carrierService
        .findAllCarrier()
        .then((res) => (this.carriers = res.data.records));
      this._productFamilyService
        .findAll()
        .then((res) => (this.productFamilies = res.data.records));
    },
    hide() {
      this.dialog = false;
    },
    add() {
      if (this.single) {
        this.$emit('selected', this.selected[0]);
      } else {
        this.$emit('selected', this.selected);
      }
      this.items = [];
      this.hide();
    },
  },
};
</script>
